import React from "react";
import CalendarSummary from "./CalendarSummary";
import KpiSummary from "./KpiSummary";
import WelcomeWidget from "./WelcomeWidget";
import WaitingJobsWidget from "./WaitingJobsWidget";
import OkrSummaryWidget from "./OkrSummaryWidget";
import DepartmentOkrWidget from "./DepartmentOkrWidget";
import OkrCompletionTimeWidget from "./OkrCompletionTimeWidget";
import OkrStatusWidget from "./OkrStatusWidget";
import OkrCompletionStatusWidget from "./OkrCompletionStatusWidget";
import OkrKrStatusWidget from "./OkrKrStatusWidget";

export const WidgetMap: Record<string, React.FC<{ mode: 'big' | 'middle' | 'small'; rowSpan?: number; colSpan?: number }>> = {
    'calendar-summary': CalendarSummary,
    'kpi-summary': KpiSummary,
    'welcome-widget': WelcomeWidget,
    'waiting-jobs-widget': WaitingJobsWidget,
    'okr-summary-widget': OkrSummaryWidget,
    'department-okr-widget': DepartmentOkrWidget,
    'okr-completion-time-widget': OkrCompletionTimeWidget,
    'okr-status-widget': OkrStatusWidget,
    'okr-completion-status-widget': OkrCompletionStatusWidget,
    'okr-kr-status-widget': OkrKrStatusWidget,
};
